var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"font-weight-medium"},[_c('v-col',{attrs:{"cols":"12"}},[_c('small',[_c('strong',[_vm._v("Instituto Pró-Hemoce")]),_vm._v(" - Sistema Administrativo - © 2020")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }